import { useState } from "react"
import { Alert, Button, Col, Image, Modal, Row } from "react-bootstrap"
import { withTranslation } from "react-i18next"
import { FaCopy, FaPaperPlane } from "react-icons/fa"
import { toast } from "react-toastify"
import Post from "../../api/Post"
import { APPOINTMENT_RESEND_NOTIFICACION } from "../../api/Routes"
import iconRecheck from '../../img/icons/recheck.svg'
import SimpleLoad from "../../loader/SimpleLoad"
import ComponentModalErrorSever from "../ComponentModalErrorSever"

function EnviarLinkCita({t, auth, item}){
    const [sendingDoc, setSendingDoc] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const [showModalServer, setShowModalServer] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const [modalShow, setModalShow] = useState(false)
    //console.log(auth)
    const sendDocument = () =>{
        setSendingDoc(true)
        Post({url: `${APPOINTMENT_RESEND_NOTIFICACION}/${item.id}/resendemail`, data: {}, access_token: auth.data.access_token, header: true})
        .then(response=>{
            console.log(response)
            setModalShow(false)
            setSendingDoc(false)
            setShowSuccess(true)
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000);
        })
        .catch(error=>{
            console.log("Error al reenviar la notifacion", error)
            setModalShow(false)
            setSendingDoc(false)
            setShowModalServer(true)
            setErrorServer(error?.response)
        })
    }
    const handleCloseSuccess = () => setShowSuccess(false);
    const handleCloseModalServer = () => setShowModalServer(false)
    const handleCloseModal = () => setModalShow(false);

    const documentosParaEnviar = async () =>{
        setModalShow(true);
    }

    const copyClipboad = async () =>{
        try {
            const r = await navigator.clipboard.writeText(item.link)
            console.log(r)
            toast.success("Link copiado", {autoClose: 3000})    
        } catch (error) {
            toast.error('Ocurrió un error mientras se copiaba el link. Por favor revise los permisos del navegador', {autoClose: 10000})
        }        
    }

    return (
        <>
            <div className="text-center">
                <Button size="sm" 
                    variant="outline-secondary" 
                    className="font-size-07rem py-0"
                    onClick={documentosParaEnviar}
                    block
                >
                    <FaPaperPlane className="pb-1" />
                    Enviar enlace
                </Button>
            </div>
            <Modal show={showSuccess} onHide={handleCloseSuccess} centered className="border-0">
                <Modal.Body className="p-0">
                    <div className="text-center position-relative overflow-hidden h-100p">
                        <Image src={iconRecheck} fluid className="img-recheck"/>
                        <h5 className="mb-0 text-app-success"> {t('solicitud_exitosa')} </h5>
                    </div>                
                </Modal.Body>
            </Modal>
            <ComponentModalErrorSever
                show={showModalServer}
                handleClose={handleCloseModalServer}
                error={errorServer}
            />
            <Modal show={modalShow} onHide={handleCloseModal} centered className="border-0">
                {sendingDoc && <SimpleLoad />}
                <Modal.Header>¿Está seguro de reenviar SMS y correo de confirmación de cita?</Modal.Header>
                <Modal.Body>
                        <Alert variant="info">
                            <div className="d-flex">
                                <div className="flex-grow-1">{item?.link}</div>
                                <div><FaCopy onClick={copyClipboad}/></div>
                            </div>
                        </Alert>                                         
                    <Row>
                        <Col className="text-right">
                            <Button 
                                variant="secondary" 
                                className="btn1"
                                onClick={handleCloseModal}
                            >Cancelar</Button>{' '}
                            <Button 
                                variant="primary" 
                                className="btn1"
                                onClick={sendDocument}
                                disabled={!item?.link}
                            >Enviar</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )

}

export default withTranslation()(EnviarLinkCita)